import * as React from "react";
import styled from "react-emotion";
import Entities from "../../../../../components/model/NamedEntityRecognition/Entities";

const InformationCard = styled("div")`
  border: 1px solid lightgrey;
  border-radius: 5px;
  padding: 10px;
  font-size: 14px;
  min-height: 30px;
  word-wrap: anywhere;
`;

const OuterSpan = styled("span")<{ bgColor: string, textColor: string }>`
  line-height: 36px;
  padding: 8px;
  border-radius: 4px;
  background-color: ${props => props.bgColor};
  color: ${props => props.textColor};
  cursor: default;
  white-space: nowrap;
`;

const InnerSpan = styled("span")<{ typeBgColor: string, typeTextColor: string }>`
  padding: 4px;
  border-radius: 2px;
  background-color: ${props => props.typeBgColor};
  color: ${props => props.typeTextColor};
  font-size: 10px;
  font-weight: bold;
  margin-left: 5px;
  vertical-align: middle;
  white-space: nowrap;
`;

const NormalSpan = styled("span")`
  line-height: 36px;
`;

interface INERModelOutputState {
    result: any;
    errorMessage: string;
}

class NERModelOutput extends React.Component<{}, INERModelOutputState> {
    constructor(props: {}) {
        super(props);

        this.state = {
            result: [],
            errorMessage: ""
        };
    }

    public beautifyResponseText(text: string) {
        const regex = new RegExp('\\s+(?=[.,?!])', 'g')
        return text.replace(regex, '');
    }

    public processResponse = (responseData: any, usesModelInput?: boolean) => {
        let data: any;
        if (usesModelInput && responseData.input && responseData.output) {
            data = {
                entities: responseData.output.entities,
                sentence: responseData.input.text
            };
        } else {
            data = responseData;
        }
        if (data && data.entities) {
            let result: any = [];
            let text = data.sentence || "";
            text = this.beautifyResponseText(text);
            let lastIndex = 0;
            const entities = data.entities;
            entities.forEach((entity: any) => {
                const word = text.substring(entity.start_pos, entity.end_pos);
                const leftPart = text.substring(lastIndex, entity.start_pos);
                lastIndex = entity.end_pos;
                result.push({
                    type: 'text',
                    text: leftPart
                }, {
                    type: 'entity',
                    text: word,
                    tag: entity.tag,
                    config: Entities[entity.tag]
                });
            });
            result.push({
                type: 'text',
                text: text.substring(lastIndex, text.length)
            });
            result = result.filter((item: any) => {
                return item.text;
            });
            this.setState({
                result
            });
        } else {
            this.setState({
                errorMessage: "Unable to extract named entities."
            });
        }
    };

    public render() {
        return <React.Fragment>
            {
                this.state.result.length ? <InformationCard>
                    {
                        this.state.result.map((item: any, index: number) => {
                            if (item.type === 'entity') {
                                const config = item.config;
                                return <span key={index} title={config.name}>
                                    <OuterSpan
                                        bgColor={config.bgColor}
                                        textColor={config.textColor}
                                    >{item.text}<InnerSpan
                                        typeBgColor={config.typeBgColor}
                                        typeTextColor={config.typeTextColor}
                                    >{item.tag}</InnerSpan>
                                    </OuterSpan>&nbsp;</span>;
                            } else {
                                return <NormalSpan>{item.text}&nbsp;</NormalSpan>;
                            }
                        })
                    }
                </InformationCard> : <></>
            }
            {
                this.state.errorMessage ? <div>
                    <InformationCard>{this.state.errorMessage}</InformationCard>
                </div> : <></>
            }
        </React.Fragment>;
    }
}

export default NERModelOutput;


// WEBPACK FOOTER //
// ./src/routes/Dashboard/CrossProvider/output/NamedEntityRecognition/NERModelOutput.tsx